import styled from 'styled-components';

export const StepsContainer = styled.section`
    .cmt-ca-marche-bloc {
        display: flex;
        align-items: center;
    }

    .digit-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${props => props.theme.black};
        border-radius: 50%;
        height: 52px;
        width: 52px;

        & > span {
            color: ${props => props.theme.white};
            font-size: 26px;
            font-weight: bold;
        }
    }

    .texte {
        display: flex;
        align-items: center;
        max-width: 240px;
        min-height: 85px;
        margin-left: 20px;

        strong {
            font-size: 15px;

            span {
                color: ${props => props.theme.howItWorkBlockBoldColor};
            }
        }
    }

    .wrapper {
        display: flex;
        justify-content: space-between;
        padding: 0;
        list-style: none;

        @media screen and (max-width: ${props => props.theme.large}) {
            margin: 0;
            flex-direction: column;

            & > * + * {
                margin-top: 20px;
            }

            .isvg {
                width: 55px;
            }
        }
    }

    @media screen and (max-width: ${props => props.theme.large}) {
        .grid-3-small-1 .texte {
            width: 70%;
        }
        .grid-3-small-1 .texte .small {
            margin-top: 2px;
        }
        .grid-3-small-1 br {
            display: none;
        }
    }

    @media screen and (max-width: ${props => props.theme.tiny}) {
        .cmt-ca-marche-bloc {
            flex-direction: column;
        }

        .texte {
            margin-left: 0;
            text-align: center;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/StepsComponentStyle.js